export const HARDENING_CLUSTERS = {
  AUDIT: 'audit' as const,
  REMOTE_ACCESS: 'remote-access' as const,
  PASSWORD_SECURITY: 'password-security' as const,
  DISK_ENCRYPTION: 'disk-encryption' as const,
  SCREEN_LOCK: 'screen-lock' as const,
  PRIVILEGE_PROTECTION: 'privilege-protection' as const,
  HOST_FIREWALL: 'host-firewall' as const,
}

export const HARDENING_POLICY_STATUS = {
  PASSED: 'passed' as const,
  WARNING: 'warning' as const,
  FAILED: 'failed' as const,
  NOT_APPLICABLE: 'not-applicable' as const,
}

export const HARDENING_ASSET_TYPES = {
  SERVER: 'server' as const,
  LAPTOP: 'laptop' as const,
}

export const CLUSTERS_MAP = {
  [HARDENING_ASSET_TYPES.SERVER]: [
    HARDENING_CLUSTERS.AUDIT,
    HARDENING_CLUSTERS.REMOTE_ACCESS,
    HARDENING_CLUSTERS.PRIVILEGE_PROTECTION,
    HARDENING_CLUSTERS.PASSWORD_SECURITY,
    HARDENING_CLUSTERS.HOST_FIREWALL,
  ],
  [HARDENING_ASSET_TYPES.LAPTOP]: [
    HARDENING_CLUSTERS.PASSWORD_SECURITY,
    HARDENING_CLUSTERS.DISK_ENCRYPTION,
    HARDENING_CLUSTERS.SCREEN_LOCK,
    HARDENING_CLUSTERS.PRIVILEGE_PROTECTION,
    HARDENING_CLUSTERS.HOST_FIREWALL,
  ],
}
